import React, { Component } from 'react';
import styled from 'styled-components';
import { CustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { DropdownHeader, DropdownContainer } from '../../dropdown';
import { Notification } from '../Notification';

/**
 * @param {string} hostOverride
 * @param {function(): void} markNotificationsSeen
 * @param {number} markNotificationsSeenTimeout
 * @param {Object[]} notifications
 * @param {function(): void} onNotificationClick
 * @param {function(): void} onSeeAllNotificationsClick
 * @returns {JSX.Element}
 */
export default class NotificationList extends Component {
    static defaultProps = {
        markNotificationsSeenTimeout: 2000,
        hostOverride: '',
    };

    componentDidMount() {
        const { markNotificationsSeen, markNotificationsSeenTimeout } =
            this.props;

        setTimeout(() => markNotificationsSeen(), markNotificationsSeenTimeout);
    }

    render() {
        const { notifications } = this.props;

        const notificationsSection =
            notifications.length === 0 ? (
                <DropdownContainer data-test="no-notifications-message">
                    {`Your notifications will show up here`}
                </DropdownContainer>
            ) : (
                this.renderNotifications()
            );

        return (
            <div>
                <DropdownHeader>{`Notifications`}</DropdownHeader>

                <Notifications data-test="notifications-container">
                    {notificationsSection}
                </Notifications>
            </div>
        );
    }

    renderNotifications() {
        const { notifications, onNotificationClick, hostOverride } = this.props;

        return (
            <CustomMetrics>
                {({ sendMetric }) =>
                    notifications
                        .filter((notification) => 'id' in notification)
                        .map((notification, i) => (
                            <Notification
                                hostOverride={hostOverride}
                                key={i}
                                notification={notification}
                                onNotificationClick={onNotificationClick}
                                sendMetric={sendMetric}
                            />
                        ))
                }
            </CustomMetrics>
        );
    }
}

const Notifications = styled.div`
    max-height: 50vh;
    overflow-y: auto;
`;
